export const FONT_SIZE_FACTOR = {
  INCREMENT: 1,
  DECREMENT: -1,
};
